export const LINKS = {
  privacy: 'https://www.debtist.de/privacy/',
};
